import { Box } from '@mui/material';
import { LoadingSkeleton, TableTitleBox, TableBodySkeleton } from '../../common/components';
import RegularizedPlansFilters from './components/RegularizedPlansFilters';
import RegularizedPlansDataTable from './components/RegularizedPlansDataTable';
import RegularizedPlansPagination from './components/RegularizedPlansPagination';
import RegularizedPlansDetailsDialog from './components/RegularizedPlansDetailsDialog';
import { useRegularizedPlansTable } from './hooks/useRegularizedPlansTable';

/**
 * Componente principal para mostrar los planes regularizados
 */
const RegularizedPlansTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,
    plans,
    groups,
    detailsDialogOpen,
    selectedItem,
    handleFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleViewDetails,
    handleCloseDetailsDialog,
  } = useRegularizedPlansTable();

  return (
    <Box>
      <TableTitleBox title="Habitat 99 | Cupones | Planes Regularizados" />

      <RegularizedPlansFilters
        filter={filter}
        handleFilter={handleFilter}
        plans={plans}
        groups={groups}
      />

      <RegularizedPlansDataTable
        data={data}
        isLoading={isLoading}
        onViewDetails={handleViewDetails}
        LoadingComponent={TableBodySkeleton}
      />

      <RegularizedPlansPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <RegularizedPlansDetailsDialog
        open={detailsDialogOpen}
        onClose={handleCloseDetailsDialog}
        item={selectedItem}
      />
    </Box>
  );
};

export default RegularizedPlansTable;
